// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsInvoices_SendEmailResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /subaccounts/invoices/send_email/{id}
 *
 * Returns {sent: bool, message: string}.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsInvoices_SendEmailResponseDados {
sent: boolean
message: string
}

export type SubaccountsInvoices_SendEmailResponse = ApiResponse<SubaccountsInvoices_SendEmailResponseDados>;

registerResponseContract('SubaccountsInvoices_SendEmailResponse', {
  sent:    { type: 'boolean', required: true },
  message: { type: 'string',  required: true },
})
